import styled from "styled-components";
import { FC } from "react";
import { Icon } from "../Icon/Icon";

export const StyledCollapsibleHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  border-radius: 4px;
  box-shadow: var(--elevation-2);
`;

export const CollapsibleHeaderTitle = styled.span`
  font-size: 64px;
`;

export const CollapsibleHeaderContent = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
  padding: 8px;
`;

export const IconClickableArea = styled.div`
  position: absolute;
  box-sizing: content-box;
  height: 32px;
`;

export const IconContract: FC = () => (
  <StyledIcon iconName="contract" iconSize="small" />
);
export const IconExpand: FC = () => (
  <StyledIcon iconName="expand" iconSize="small" />
);

const StyledAddContent = styled.div`
  display: flex;
  height: 88px;
  width: 100%;
  padding: 8px;
  cursor: pointer;
  div {
    flex: 1;
  }
`;

const Column = styled.div`
  /* Tablet breakpoint */
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const AddContentLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border-right: 1px solid var(--color-primary-300);
  border-left: 1px solid var(--color-primary-300);

  color: var(--color-primary-400);
  font-family: var(--font-family-alpha);
  font-size: var(--size-font-base);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-normal);

  svg {
    --main-color: var(--color-primary-400);
  }

  /* Tablet breakpoint */
  @media only screen and (max-width: 768px) {
    border: none;
  }
`;

type CollapsibleHeaderAddContentProps = {
  onAddContent: () => void;
};

export const CollapsibleHeaderAddContent: FC<CollapsibleHeaderAddContentProps> =
  ({ onAddContent }) => (
    <StyledAddContent onClick={onAddContent}>
      <Column />
      <AddContentLabel>
        <Icon iconName="add" plain />
        <span>Add collection details</span>
      </AddContentLabel>
      <Column />
    </StyledAddContent>
  );
